import { format } from 'date-fns'

export default {
    GET_CAR_RESERVATIONS_SUCCESS: (state, data) => {
        data.results.forEach(reservation => {
            reservation.start = reservation.startDate
            reservation.end = reservation.endDate
            reservation.title = reservation.name
            reservation.resourceId = reservation.carType.id
            reservation.textColor = 'white'

            if (reservation.createdBy.firstName && reservation.createdBy.lastName) {
                reservation.description = {'reservationName': reservation.name,
                    'reservationDate': `${format(new Date(reservation.startDate), 'HH:mm')} - ${format(new Date(reservation.endDate), 'HH:mm')}`,
                    'reservationCreatedBy': `${reservation.createdBy.firstName} ${reservation.createdBy.lastName}`,
                    'reservationStatus': `${reservation.carReservationStatus.name}`}
            } else {
                reservation.description = {'reservationName': reservation.name,
                    'reservationDate': `${format(new Date(reservation.startDate), 'HH:mm')} - ${format(new Date(reservation.endDate), 'HH:mm')}`,
                    'reservationCreatedBy': `${reservation.createdBy.username}`,
                    'reservationStatus': `${reservation.carReservationStatus.name}`}
            }
            reservation.backgroundColor= `#${reservation.carType.colour}`
            reservation.borderColor = 'rgba(0, 0, 0, 0)'
            state.carReservations.push(reservation)
        })
        state.carReservations = data.results

    },
    GET_CAR_RESERVATIONS_TYPES_SUCCESS: (state, data) => {
        state.carReservationsTypes = data
    },
    GET_CAR_RESERVATIONS_STATUSES_SUCCESS: (state, data) => {
        state.carReservationsStatuses = data
    },
    CLEAR_CAR_RESERVATIONS: state => {
        state.carReservations = []
    },
}